"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createSegment: function() {
        return createSegment;
    },
    deleteSegment: function() {
        return deleteSegment;
    },
    duplicateSegment: function() {
        return duplicateSegment;
    },
    generateSegments: function() {
        return generateSegments;
    },
    randomiseSegment: function() {
        return randomiseSegment;
    },
    resetSegments: function() {
        return resetSegments;
    },
    simulateSegment: function() {
        return simulateSegment;
    },
    updateSegment: function() {
        return updateSegment;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createSegment(payload) {
    return {
        type: _types.ADD_SEGMENT,
        payload
    };
}
function randomiseSegment({ productionId = false, segmentId }) {
    return {
        type: _types.RANDOMISE_SEGMENT,
        payload: {
            productionId,
            segmentId
        }
    };
}
function duplicateSegment(payload) {
    return {
        type: _types.DUPLICATE_SEGMENT,
        payload
    };
}
function updateSegment(payload) {
    return {
        type: _types.UPDATE_SEGMENT,
        payload
    };
}
function deleteSegment(payload) {
    return {
        type: _types.DELETE_SEGMENT,
        payload
    };
}
function resetSegments() {
    return {
        type: _types.RESET_SEGMENTS
    };
}
function simulateSegment(id, productionId = false) {
    return {
        type: _types.SIMULATE_SEGMENT,
        payload: {
            id,
            productionId
        }
    };
}
function generateSegments(payload) {
    return {
        type: _types.GENERATE_SEGMENTS,
        payload
    };
}
